import { BrowserRouter, Routes, Route } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import ScrollToTop from "./Pages/ScrollTotop";
import { useEffect } from "react";
import Header from "./Pages/Header";
import Footer from "./Pages/Footer";
import Home from "./Pages/Home";
import About from "./Pages/About";
import Team from "./Pages/Team";
import Testimonials from "./Pages/Testinomials";
import Service from "./Pages/Service";
import Portfolio from "./Pages/Portfolio";
import Contact from "./Pages/Contact";
import "./Pages/Design.css";
function App() {
  useEffect(() => {
  AOS.init({
    duration: 2000, 
    once: true,     
  });
}, []);
  return (
    <>
      <BrowserRouter>
       <ScrollToTop />
       <Header/>
      <br></br>
      <br></br>
        <Routes>
          <Route path="" element={<Home />}/>
          <Route path="/about" element={<About/>}/>
          <Route path="/team" element={<Team/>}/>
          <Route path="/testinomials" element={<Testimonials/>}/>
          <Route path="/service" element={<Service/>}/>
          <Route path="/portfolio" element={<Portfolio/>}/>
          <Route path="/contact" element={<Contact/>}/>
        </Routes>
        <Footer/>
      </BrowserRouter>
    </>
  );
}

export default App;
